import { Text } from "@chakra-ui/react";
import { IFeedCardPriceBody } from "src/components/feed-card/types/content";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";

export const FeedCardPrice = ({ currency, value }: IFeedCardPriceBody) => {
    const { formatNumber } = useNumberFormatter();

    return (
        <Text as="span">
            {currency}&nbsp;{formatNumber(value, 2)}
        </Text>
    );
};
